{
  "delete": "Effacer",
  "comment": "commentaires",
  "production_company": "Companie de production ",
  "city": "Ville",
  "languages": "Langues",
  "TV_campaigns": "TV campaigns",
  "awards": "Awards",
  "files_and_links": "Fichiers et liens",
  "social_accounts": "Réseaux socieuax"
}
